<style lang="stylus" scoped>
@import '../cardMap.stylus';

.map-card-cont .map-card-lib:nth-child(even) {
  background: #F8F8F8;
}

.map-card-cont {
  border: 1px solid #ccc;
  background:#fff;
}
.map-card{
  background:unset ;
}
</style>
<template>
  <div class="map-card">
    <div class="map-card-t">
      <el-row>
        <el-col :span="12">车辆注册省</el-col>
      </el-row>
    </div>
    <div class="map-card-cont" v-if="cardItem&&cardItem.length && total>0">
      <div class="map-card-lib" style="margin-top:0;border:0;border-radius:0;">
        <div class="_lib1">合计</div>
        <div class="_lib3">{{format(total)}}次</div>
      </div>
      <div
        class="map-card-lib"
        style="margin-top:0;border:0;border-radius:0;"
        v-for="(it,index) in list"
        :key="index"
      >
        <div class="_lib1">{{it.registProvince}}</div>
        <div class="_lib3">{{it.registPathway?it.registPathway:format(it.countNum)+'次'}}</div>
      </div>
    </div>
    <div class="map-card-cont" v-else><rightBox/></div>
  </div>
</template>

<script>
import http from '@/api/cardData'
import Bus from '@/utils/Bus.js'
export default {
  name: 'mapCard',
  data() {
    return {
      cardItemLeth: 0,
      details: {},
      list: []
    }
  },
  props: {
    cardItem: [Array, Object],
    time: Array,
    total: Number
  },
  watch: {
    cardItem: function(value, oldValue) {
      if (this.cardItem.length) {
        let list = this.cardItem.slice(0)
        list.sort((a, b) => {
          return b.countNum * 1 - a.countNum * 1
        })
        this.list = [...list]
      }
    }
  },
  created() {
  },
  mounted() {
    if (this.cardItem.length) {
      let list = this.cardItem
      list.sort((a, b) => {
        return a.countNum * 1 - b.countNum * 1
      })
      this.list = [...list]
    }
  },
  methods: {
    format(num) {
      if (num == -1) {
        return '--'
      } else {
        var reg = /\d{1,3}(?=(\d{3})+$)/g
        return (num + '').replace(reg, '$&,')
      }
    }
  }
}
</script>
